import { Box, merge } from "theme-ui";

import * as styles from "./LoadingIndicator.styles";

function LoadingIndicator({ sx = {}, ...props }) {
  return (
    <Box sx={merge(styles.div, sx)} {...props}>
      <svg viewBox="25 25 50 50">
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
      </svg>
    </Box>
  );
}

export default LoadingIndicator;
